import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { format, subDays } from 'date-fns';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IDashboardCharts, IDashboardTradeItem } from '../types/app-dashboard.types';

interface AppDashboardState extends BaseDataReducerV2InitialState<IDashboardTradeItem> {
  perPage: number;
  charts: IDashboardCharts | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducerV2<IDashboardTradeItem, AppDashboardState>(
  'app-dashboard',
);

const appDashboardState: AppDashboardState = {
  ...initialState,
  perPage: 15,
  filters: {
    periodStartDate: format(subDays(new Date(), 7), 'dd.MM.yyyy'),
    periodEndDate: format(new Date(), 'dd.MM.yyyy'),
  },
  charts: null,
};

export const appDashboard = createSlice({
  name: 'appDashboard',
  initialState: appDashboardState,
  reducers: {
    setCharts(state, action: PayloadAction<IDashboardCharts | null>) {
      state.charts = action.payload;
    },
    clearState(state) {
      state = appDashboardState;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as AppDashboardState, action);
    });
  },
});
export const AppDashboardAC = AC;
export const setAppDashboardCurrentPage = AC.setCurrentPage;
export const onAppDashboardFilter = thunks.onFilter;
export const { clearState, setCharts } = appDashboard.actions;
